module.exports = __webpack_public_path__ + "img/we_0.bad52e37.png";